module.exports = __webpack_public_path__ + "img/conference4.ff3c1827.png";